<app-modal #modal [modalConfig]="modalConfig">
  <div class="d-flex flex-column justify-content-center align-items-center">
    <i class="bi bi-exclamation-circle"></i>
    <div class="text-center description" i18n
      >Are you sure that you want to remove this item from cart?</div
    >
  </div>
</app-modal>
